import type { DocBlock } from "./blockTypes";

/** Backfill optional fields on snapshots saved before fill-block extensions. */
export function normalizeDocBlock(block: DocBlock): DocBlock {
  if (block.type === "signature_line") {
    const row = block as DocBlock & {
      signature_variable_key?: string;
      date_label?: string;
      date_variable_key?: string;
    };
    return {
      ...block,
      signature_variable_key: row.signature_variable_key ?? "",
      date_label: row.date_label?.trim() || "Date",
      date_variable_key: row.date_variable_key ?? "",
    };
  }
  return block;
}

export function normalizeDocBlocks(blocks: DocBlock[]): DocBlock[] {
  return blocks.map((block) => {
    const normalized = normalizeDocBlock(block);
    if (normalized.type === "two_column") {
      return {
        ...normalized,
        left: normalized.left.map((b) => normalizeDocBlock(b) as (typeof normalized.left)[number]),
        right: normalized.right.map((b) => normalizeDocBlock(b) as (typeof normalized.right)[number]),
      };
    }
    return normalized;
  });
}
